module.exports = __webpack_public_path__ + "img/google-play1.0cb62221.png";